<template>
  <div>
    <v-dialog v-model="show" :max-width="width" flat elevation="0" persistent>
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5 px-5">
        <v-card-title v-if="joinStatus" class="px-0">
          <div class="mb-4">
            <user-list-item
              :item="user"
              :avatar="user.Avatar"
              :fullName="user.FullName"
              :department="user.Department"
              :userId="user.Id"
              :company="user.Company"
              :noGotoProfile="true"
              :noBg="true"
              :divider="false"
            />
          </div>

          <v-layout justify-center align-center>
            <session-component
            :sessionId="sessionId"
            :apiKey="apiKey"
            :token="token"
            :publisher="false"
            @streamDestroyed="streamDestroyed"
            @streamCreated="(n) => streamCreated(n)"
          />
          </v-layout>
          
        </v-card-title>

        <v-card-title
          v-else-if="loading && !streamDestroyedStatus"
          class="pb-7"
        >
          <loading-progress :status="loading" />
        </v-card-title>

        <v-card-title v-else-if="!loading && streamDestroyedStatus">
          <div
            class="defaultColor--text font-weight-regular text-center px-12"
            style="font-size: 15px; line-height: 25px; width: 100%"
          >
            {{ $t("description.endLiveStream") }}
          </div>
        </v-card-title>

        <v-card-actions
          v-else-if="!loading && streamDestroyedStatus"
          class="justify-center align-center pb-5 mt-0"
        >
          <v-btn
            color="greenColor"
            class="white--text text-capitalize rounded-pill"
            block
            height="67"
            elevation="0"
            rounded
            large
            @click="closeModal()"
          >
            {{ $t("buttons.startStream") }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="closeModal" />
    </v-dialog>
  </div>
</template>

<script>
import DialogCloseButton from "../General/DialogCloseButton.vue";
import BroadcastService from "../../services/BroadcastService";
import SessionComponent from "./Session.vue";
import LoadingProgress from "../General/LoadingProgress.vue";
import UserListItem from "../Users/UserListItem.vue";
import moment from "moment";

export default {
  data() {
    return {
      startStatus: false,
      sessionId: null,
      apiKey: null,
      token: null,
      user: null,
      startDate: null,
      broadcastId: null,
      streamDestroyedStatus: false,
      loading: true,
      width: 400,
    };
  },
  props: {
    visible: Boolean,
  },
  mounted() {},
  components: {
    DialogCloseButton,
    SessionComponent,
    LoadingProgress,
    UserListItem,
  },
  methods: {
    startJoinLiveStream() {
      console.log("broadcastId :", this.$store.state.getOnGoingBroadcastsId);
      if (this.$store.state.getOnGoingBroadcastsId) {
        this.getStream(this.$store.state.getOnGoingBroadcastsId);
      } else {
        window.showInfo(
          this.$t("description.noLiveStream"),
          "standart",
          "error"
        );
        this.$router.go();
      }
    },

    getStream(id) {
      this.loading = true;
      BroadcastService.getOnGoingBroadcasts(id)
        .then((res) => {
          if (res.data.length > 0) {
            this.apiKey = res.data[0].ApiKey.toString();
            this.sessionId = res.data[0].SessionId;
            this.token = res.data[0].Token;
            this.user = res.data[0].User;
            this.startDate = moment(res.data[0].CreatedAt).fromNow();
            this.broadcastId = res.data[0].BroadcastId;
            this.sendBroadCastJoinInfo(res.data[0].BroadcastId);
          } else {
            this.streamDestroyed();
            console.log("Res data is empty");
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.startStatus = true
          this.loading = false
        });
    },

    sendBroadCastJoinInfo(id) {
      BroadcastService.sendBroadCastJoinInfo(id)
        .then((res) => {})
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },

    streamDestroyed() {
      console.log("streamDestroyeddd");
      this.startStatus = false;
      this.apiKey = null;
      this.sessionId = null;
      this.token = null;

      this.loading = false;

      this.streamDestroyedStatus = true;
    },

    streamCreated(n){
        this.width = n.videoDimensions.width
    },

    closeModal() {
      this.startStatus = false;
      this.sessionId = null;
      this.apiKey = null;
      this.token = null;
      this.user = null;
      this.startDate = null;
      this.broadcastId = null;
      this.streamDestroyedStatus = false;
      this.loading = false;
      this.show = false;
      this.$store.state.joinLiveStreamDialoStatus = false;
      this.$router.go();
    },
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.startJoinLiveStream();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    joinStatus() {
      if (
        this.startStatus &&
        this.apiKey &&
        this.sessionId &&
        this.token &&
        !this.loading
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
};
</script>
